module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns flex-column-reverse-is-mobile"
  }, [_c('div', {
    staticClass: "column is-narrow max-width-300px-if-not-mobile"
  }, [_c('aside', {
    staticClass: "menu"
  }, [_c('FolderSection'), _vm._v(" "), _c('GroupsSection')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [(!_vm.legacyUploader && _vm.mayUploadVideo) ? _c('Uppy') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center mb-4 flex-wrap-reverse-if-mobile"
  }, [_c('div', {
    staticClass: "d-flex align-items-center w-100"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "input mt-0 br-0 mr-2",
    attrs: {
      "type": "search",
      "placeholder": "search all videos"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "d-flex align-items-center if-not-mobile",
    class: _vm.rows && 'is-active',
    attrs: {
      "data-balloon": "List View",
      "data-balloon-pos": "down"
    },
    on: {
      "click": function($event) {
        _vm.rows = true
      }
    }
  }, [_c('BarsIcon', {
    attrs: {
      "fill": _vm.rows ? 'black' : '#dbdbdb',
      "width": "25px"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "pl-2 d-flex align-items-center mr-2 if-not-mobile",
    class: !_vm.rows && 'is-active',
    attrs: {
      "data-balloon": "Grid View",
      "data-balloon-pos": "down"
    },
    on: {
      "click": function($event) {
        _vm.rows = false
      }
    }
  }, [_c('TableIcon', {
    attrs: {
      "fill": _vm.rows ? 'black' : '#dbdbdb',
      "width": "25px"
    }
  })], 1)]), _vm._v(" "), _c('button', {
    staticClass: "button is-info w-100-if-mobile mb-4-if-mobile",
    attrs: {
      "type": "button",
      "id": "add-video",
      "disabled": !_vm.mayUploadVideo,
      "name": "add video"
    }
  }, [_vm._v("\n      + Add Video\n    ")]), _vm._v(" "), (_vm.permGoogleDrive) ? _c('GoogleFilePicker') : _vm._e()], 1), _vm._v(" "), _c('section', [_c('p', {
    staticClass: "mb-4"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Filter:")]), _vm._v(" "), _c('a', {
    staticClass: "filter",
    class: {
      'activeFilter': _vm.filterBy == 'ALL'
    },
    on: {
      "click": function($event) {
        _vm.filterBy = 'ALL'
      }
    }
  }, [_vm._v("All Videos")]), _vm._v(" "), _c('span', [_vm._v("|")]), _vm._v(" "), _c('a', {
    staticClass: "filter",
    class: {
      'activeFilter': _vm.filterBy == 'MY_VIDEOS'
    },
    on: {
      "click": function($event) {
        _vm.filterBy = 'MY_VIDEOS'
      }
    }
  }, [_vm._v("My Videos")]), _vm._v(" "), _c('span', [_vm._v("|")]), _vm._v(" "), _c('a', {
    staticClass: "filter",
    class: {
      'activeFilter': _vm.filterBy == 'SHARED_WITH_ME'
    },
    on: {
      "click": function($event) {
        _vm.filterBy = 'SHARED_WITH_ME'
      }
    }
  }, [_vm._v("Shared with Me")])]), _vm._v(" "), (_vm.loading) ? _c('section', {
    staticClass: "d-flex justify-content-center w-100 align-items-center"
  }, [_c('Loader')], 1) : _c('VideosTable', {
    class: _vm.rows ? 'rows' : 'grid',
    attrs: {
      "videos": _vm.selectedVideos
    }
  }), _vm._v(" "), (_vm.noVideos && !_vm.loading) ? _c('div', {
    staticClass: "d-flex align-items-center flex-column"
  }, [(_vm.mayUploadVideo) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('p', {
    staticClass: "text-muted text-center fs-2rem"
  }, [_vm._v("You haven't uploaded any videos yet.")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.mayUploadVideo) ? _c('div', {
    staticClass: "d-flex align-items-center flex-column"
  }, [_c('p', {
    staticClass: "text-muted text-center fs-1rem"
  }, [_vm._v("\n            You must confirm your email address to enable uploading.\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary mt-1",
    class: {
      'is-loading': _vm.loadingResendEmailConfirmation
    },
    on: {
      "click": _vm.resendConfirmationEmail
    }
  }, [_vm._v("\n              Resend confirmation email\n          ")])]) : _vm._e()]) : (_vm.nothingFound && !_vm.loading) ? _c('div', {
    staticClass: "d-flex align-items-center flex-column"
  }, [_c('p', {
    staticClass: "text-muted text-center fs-2rem break-word"
  }, [_vm._v("\n          No videos found matching: "), _c('strong', [_vm._v(_vm._s(_vm.query))])])]) : _vm._e(), _vm._v(" "), (_vm.filterBy === 'SHARED_WITH_ME' && _vm.noSharedVideos && !_vm.loading) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('p', {
    staticClass: "text-muted text-center fs-2rem"
  }, [_vm._v("No videos have been shared with you yet.")]), _vm._v(" "), _vm._m(1)]) : _vm._e()], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-muted text-center fs-1rem"
  }, [_vm._v("Use the "), _c('b', [_vm._v("+ Add Video")]), _vm._v(" button above.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-muted text-center fs-1rem"
  }, [_vm._v("\n          Try the "), _c('b', [_vm._v("share")]), _vm._v(" button on the video page.\n        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-7cd6a61a"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Videos.vue
// module id = 1071
// module chunks = 0